import * as React from 'react';

function SvgAreaWarning(props: React.SVGProps<SVGSVGElement>): any {
    return (
        <svg width="50" height="51" viewBox="0 0 50 51" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <circle cx="25" cy="25" r="25" fill="#FFA02F" />
            <path
                d="M26.9336 10.9091L26.6495 31.8182H23.354L23.07 10.9091H26.9336ZM25.0018 40.2273C24.301 40.2273 23.6997 39.9763 23.1978 39.4744C22.6959 38.9725 22.445 38.3712 22.445 37.6705C22.445 36.9697 22.6959 36.3684 23.1978 35.8665C23.6997 35.3646 24.301 35.1136 25.0018 35.1136C25.7025 35.1136 26.3039 35.3646 26.8058 35.8665C27.3076 36.3684 27.5586 36.9697 27.5586 37.6705C27.5586 38.1345 27.4402 38.5606 27.2035 38.9489C26.9762 39.3371 26.6684 39.6496 26.2802 39.8864C25.9014 40.1136 25.4753 40.2273 25.0018 40.2273Z"
                fill="white"
            />
        </svg>
    );
}

export default SvgAreaWarning;
